import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiEncargosInstance, authHeaderEncargos } from "../../redux/actions/encargos/encargos";

import { Form, Input, Select, Button, Row, Col, Typography, Space, InputNumber } from "antd";
import { toast } from "../../components/toasts/toastStore";

import "./EventosPage.css";
import "./PaquetesPage.css";

const { Title, Text } = Typography;

export default function CrearEncargoPage() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [variantes, setVariantes] = useState([]);
  const tipo = Form.useWatch("tipo", form);

  useEffect(() => {
    apiEncargosInstance.get("/clientes", { headers: authHeaderEncargos() })
      .then((r) => setClientes((r.data?.items ?? []).map((c) => ({ label: c.nombre, value: c.id_cliente }))))
      .catch(() => {});
    apiEncargosInstance.get("/proveedores", { headers: authHeaderEncargos() })
      .then((r) => setProveedores((r.data?.items ?? []).map((p) => ({ label: p.nombre, value: p.id_proveedor }))))
      .catch(() => {});
    apiEncargosInstance.get("/productos/variantes/buscar", { headers: authHeaderEncargos() })
      .then((r) => setVariantes((r.data?.items ?? []).map((v) => ({ label: `${v.producto_nombre} (${v.clave})`, value: v.id_variante }))))
      .catch(() => {});
  }, []);

  const handleSave = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch {
      return;
    }

    const payload = {
      tipo: values.tipo,
      id_cliente: values.id_cliente,
      descripcion: values.descripcion.trim(),
      id_variante: values.tipo === "apartado" ? values.id_variante : (values.id_variante || null),
      id_proveedor: values.id_proveedor || null,
      anticipo: values.anticipo ?? null,
    };

    setSaving(true);
    try {
      const { data } = await apiEncargosInstance.post("/encargos", payload, { headers: authHeaderEncargos() });
      toast.success(`${values.tipo === "apartado" ? "Apartado" : "Encargo"} registrado`);
      navigate(`/app/encargos/${data.id}`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || err.message || "Error al registrar");
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="paq-main">
      <div className="paq-content">
        <section className="cc-page-header-card">
          <Space direction="vertical" size={2}>
            <Title level={2} className="eventos-title" style={{ marginBottom: 0 }}>Nuevo encargo/apartado</Title>
            <Text className="eventos-subtitle">Registra un producto pedido a proveedor o reservado para un cliente.</Text>
          </Space>

          <Space>
            <Button className="eventos-btn-clean" onClick={() => navigate("/app/encargos")} disabled={saving}>Cancelar</Button>
            <Button type="primary" loading={saving} icon={<i className="fa-solid fa-plus" />} onClick={handleSave} style={{ backgroundColor: "#f90336", borderColor: "#f90336" }}>
              Registrar
            </Button>
          </Space>
        </section>

        <Form form={form} layout="vertical" initialValues={{ tipo: "encargo" }}>
          <div className="cc-section-card">
            <div className="cc-section-header">
              <span className="cc-section-icon"><i className="fa-solid fa-box-archive"></i></span>
              Datos del registro
            </div>

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item name="tipo" label={<span className="paq-field-label">Tipo</span>} rules={[{ required: true, message: "Requerido" }]}>
                  <Select
                    options={[
                      { label: "Encargo (se pide a proveedor)", value: "encargo" },
                      { label: "Apartado (ya existe en tienda)", value: "apartado" },
                    ]}
                    onChange={() => form.setFieldValue("id_variante", undefined)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="id_cliente" label={<span className="paq-field-label">Cliente</span>} rules={[{ required: true, message: "Requerido" }]}>
                  <Select placeholder="Selecciona cliente" options={clientes} showSearch optionFilterProp="label" />
                </Form.Item>
              </Col>
            </Row>

            {tipo === "apartado" ? (
              <Row gutter={16}>
                <Col xs={24}>
                  <Form.Item name="id_variante" label={<span className="paq-field-label">Producto a apartar</span>} rules={[{ required: true, message: "Selecciona el producto existente" }]}>
                    <Select placeholder="Selecciona la variante en inventario" options={variantes} showSearch optionFilterProp="label" />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item name="descripcion" label={<span className="paq-field-label">Notas (opcional)</span>}>
                    <Input.TextArea rows={2} placeholder="Detalles adicionales del apartado..." />
                  </Form.Item>
                </Col>
              </Row>
            ) : (
              <>
                <Row gutter={16}>
                  <Col xs={24}>
                    <Form.Item name="descripcion" label={<span className="paq-field-label">Descripcion</span>} rules={[{ required: true, message: "Requerido" }]}>
                      <Input.TextArea rows={2} placeholder="Que se le esta encargando al cliente..." />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item name="id_proveedor" label={<span className="paq-field-label">Proveedor (opcional)</span>}>
                      <Select placeholder="Selecciona proveedor" options={proveedores} showSearch optionFilterProp="label" allowClear />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item name="id_variante" label={<span className="paq-field-label">Vincular a producto existente (opcional)</span>}>
                      <Select placeholder="Solo si ya existe en el catalogo" options={variantes} showSearch optionFilterProp="label" allowClear />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item name="anticipo" label={<span className="paq-field-label">Anticipo (opcional)</span>}>
                  <InputNumber style={{ width: "100%" }} min={0} precision={2} placeholder="0.00" />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
      </div>
    </main>
  );
}
